"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(["\n  max-width:950px;\n  min-width:320px;\n  margin:0 auto;\n\n  ", ";\n"], ["\n  max-width:950px;\n  min-width:320px;\n  margin:0 auto;\n\n  ", ";\n"]);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents2.default.div(_templateObject, function (props) {
  return props.noStyle ? "" : "background:#f2f2f2; padding:30px; border-top:5px solid #003da5;";
});

exports.default = Container;